const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

/**
 * Helper pour les requêtes avec authentification JWT
 */
const fetchWithAuth = async (url, options = {}) => {
  const token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Erreur serveur' }));
    throw new Error(error.message || `Erreur ${response.status}`);
  }

  return response.json();
};

/**
 * Service pour gérer les circuits de poker
 */
const circuitsService = {
  /**
   * Récupérer tous les circuits
   */
  getAll: async () => {
    try {
      const data = await fetchWithAuth(`${API_URL}/circuits`);
      return data.data || [];
    } catch (error) {
      console.error('Erreur circuits:', error);
      throw error;
    }
  },

  /**
   * Récupérer un circuit par ID
   */
  getById: async (id) => {
    try {
      const data = await fetchWithAuth(`${API_URL}/circuits/${id}`);
      return data.data;
    } catch (error) {
      console.error('Erreur circuit:', error);
      throw error;
    }
  },

  /**
   * Récupérer un circuit par acronyme
   */
  getByAcronym: async (acronym) => {
    try {
      const data = await fetchWithAuth(`${API_URL}/circuits/acronym/${acronym}`);
      return data.data;
    } catch (error) {
      console.error('Erreur circuit:', error);
      throw error;
    }
  }
};

export default circuitsService;